exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a,a:hover{color:#777}.icon{color:#189ce2;border-color:#168ccb;font-size:1.8rem;margin:-5px}", "", {"version":3,"sources":["/./src/components/app/general_notification_components/NotifyUserOnClient.vue"],"names":[],"mappings":"AAIA,UACI,UAAe,CAClB,AACD,MACI,cAAe,AACf,qBAAsB,AACtB,iBAAkB,AACrB,WAAa,CACb","file":"NotifyUserOnClient.vue","sourcesContent":["\na:hover {\n    color: #777777;\n}\na {\n    color: #777777;\n}\n.icon {\n    color: #189ce2;\n    border-color: #168ccb;\n    font-size: 1.8rem;\n\tmargin: -5px;\n}\n\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-c4aa1f4a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/general_notification_components/NotifyUserOnClient.vue
// module id = 617
// module chunks = 2